/* eslint-disable */
export const lang = state => {
	if (state) {
		return state.lang;
	}
};
